import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMapDirectionsLinkFactory } from 'site-modules/shared/utils/map-utils';

const BLANK_TARGET = '_blank';

function MapLinkUI({
  location,
  children,
  mapProvider,
  mapLinkFactory = getMapDirectionsLinkFactory,
  ...otherLinkProps
}) {
  // clear props added by react-redux connect function
  delete otherLinkProps.dispatch;
  delete otherLinkProps.store;
  delete otherLinkProps.storeSubscription;

  const url = mapLinkFactory({ location, mapProvider });

  const rel = otherLinkProps.target === BLANK_TARGET ? 'noopener noreferrer' : otherLinkProps.rel;

  return (
    <a href={url} {...otherLinkProps} rel={rel}>
      {children}
    </a>
  );
}

MapLinkUI.propTypes = {
  location: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  mapProvider: PropTypes.string.isRequired,
  mapLinkFactory: PropTypes.func,
};

const mapStateToProps = state => ({
  mapProvider: state.devicePlatform.mapProvider,
});

export const MapLink = connect(mapStateToProps)(MapLinkUI);
